import { render, staticRenderFns } from "./Feature1.vue?vue&type=template&id=5c6f132c"
import script from "./Feature1.vue?vue&type=script&lang=js"
export * from "./Feature1.vue?vue&type=script&lang=js"
import style0 from "./Feature1.vue?vue&type=style&index=0&id=5c6f132c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports